export const theme = {
  colors: {
    primary: '#87CEEB',      // Azul claro
    secondary: '#98FB98',    // Verde menta
    background: 'transparent',   // Transparente para mostrar el fondo
    surface: 'rgba(248, 251, 253, 0.95)',      // Blanco azulado semi-transparente
    text: {
      primary: '#2C3E50',
      secondary: '#7F8C8D',
      inverse: '#FFFFFF'
    },
    error: '#E74C3C',
    warning: '#F39C12',
    success: '#27AE60',
    info: '#3498DB',
    border: '#E1E8ED',
    shadow: 'rgba(0, 0, 0, 0.1)'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px'
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '32px'
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  },
  breakpoints: {
    mobile: '640px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px'
  },
  transitions: {
    fast: '150ms ease-in-out',
    base: '250ms ease-in-out',
    slow: '350ms ease-in-out'
  }
};